var app = app || {};
(function () {
    app.localStorage = app.localStorage || {};

    app.localStorage.setItem = function (key, value) {
        return new Promise((resolve, reject) => {
            if (!window.localStorage) {
                reject();
            }

            window.localStorage.setItem(key, JSON.stringify(value));

            resolve();
        });
    };

    app.localStorage.getItem = function (key) {
        return new Promise((resolve, reject) => {
            if (!window.localStorage) {
                reject();
            }

            resolve(JSON.parse(window.localStorage.getItem(key)));
        });
    };

    app.localStorage.removeItem = function (key) {
        return new Promise((resolve, reject) => {
            if (!window.localStorage) {
                reject();
            }

            window.localStorage.removeItem(key);

            resolve();
        });
    };

    app.localStorage.clear = function () {
        return new Promise((resolve, reject) => {
            if (!window.localStorage) {
                reject();
            }

            window.localStorage.clear();

            resolve();
        });
    };


    app.sessionStorage = app.sessionStorage || {};

    app.sessionStorage.setItem = function (key, value) {
        return new Promise((resolve, reject) => {
            if (!window.sessionStorage) {
                reject();
            }

            window.sessionStorage.setItem(key, JSON.stringify(value));

            resolve();
        });
    };

    app.sessionStorage.getItem = function (key) {
        return new Promise((resolve, reject) => {
            if (!window.sessionStorage) {
                reject();
            }

            resolve(JSON.parse(window.sessionStorage.getItem(key)));
        });
    };

    app.sessionStorage.removeItem = function (key) {
        return new Promise((resolve, reject) => {
            if (!window.sessionStorage) {
                reject();
            }

            window.sessionStorage.removeItem(key);

            resolve();
        });
    };

    app.sessionStorage.clear = function () {
        return new Promise((resolve, reject) => {
            if (!window.sessionStorage) {
                reject();
            }

            window.sessionStorage.clear();

            resolve();
        });
    };
})();
